// ABOUTME: Translated messages of the local read filter validation errors (readFilterDrafts validators).
// ABOUTME: The server-side errors (allowlist, EXPLAIN) come back as their own message on save.

import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ReadFilterErrorCode } from '../utils/readFilterDrafts';

export function useReadFilterErrorMessages() {
    const intl = useIntl();
    return useCallback(
        (code: ReadFilterErrorCode): string => {
            switch (code) {
                case 'invalid-code':
                    return intl.formatMessage({
                        id: 'read-filters.error.invalid-code',
                        defaultMessage: 'A letter, then letters, digits or _',
                    });
                case 'duplicate-code':
                    return intl.formatMessage({
                        id: 'read-filters.error.duplicate-code',
                        defaultMessage: 'Another filter of this schema has this code',
                    });
                case 'empty-expression':
                    return intl.formatMessage({
                        id: 'read-filters.error.empty-expression',
                        defaultMessage: 'The expression is required',
                    });
                case 'expression-too-long':
                    return intl.formatMessage({
                        id: 'read-filters.error.expression-too-long',
                        defaultMessage: 'At most 4000 characters',
                    });
                case 'invalid-timeout':
                    return intl.formatMessage({
                        id: 'read-filters.error.invalid-timeout',
                        defaultMessage: 'Between 100 and 30000 ms',
                    });
                default:
                    return code;
            }
        },
        [intl],
    );
}
